import React from 'react';
import { MapPin, Phone } from 'lucide-react';

function Footer() {
  return (
    <footer className="bg-[#F3ECE1] border-t border-[#E1DFD7] mt-auto py-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-3 gap-8 items-start text-xs text-[#5A5750]">
        
        {/* Left Column: Brand Identity & Legal */}
        <div className="space-y-2 text-center md:text-left">
          <p className="font-semibold text-[#2C2A27] uppercase tracking-wider">
            &copy; {new Date().getFullYear()} Mridangas Musical Store
          </p>
          <p className="text-[11px] text-[#8A867E] font-light">
             All Rights Reserved.
          </p>
          
          {/* Social Links Container */}
          <div className="pt-2 flex flex-col gap-2 items-center md:items-start">
            {/* Instagram Integration Link via raw semantic SVG */}
            <a 
              href="https://www.instagram.com/mridangasofficial/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="inline-flex items-center gap-2 text-[#8A867E] hover:text-[#9A7B56] transition-colors font-medium tracking-wide"
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                className="w-4 h-4"
              >
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
              </svg>
              <span>@mridangasofficial</span>
            </a>

            {/* YouTube Integration Link via raw semantic SVG */}
            <a 
              href="https://www.youtube.com/@Mridangasofficial/featured" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="inline-flex items-center gap-2 text-[#8A867E] hover:text-[#9A7B56] transition-colors font-medium tracking-wide"
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                className="w-4 h-4"
              >
                <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17z"/>
                <polygon points="10 15 15 12 10 9" fill="currentColor"/>
              </svg>
              <span>Mridangas Official</span>
            </a>
          </div>
        </div>

        {/* Center Column: Studio Headquarters Address & Contact */}
        <div className="space-y-4 text-center md:text-left border-y md:border-y-0 border-[#E1DFD7] py-6 md:py-0">
          <div className="space-y-1.5">
            <p className="font-semibold text-[#2C2A27] uppercase tracking-widest text-[10px] flex items-center justify-center md:justify-start gap-1.5">
              <MapPin className="w-3.5 h-3.5 text-[#9A7B56]" /> Studio Location
            </p>
            <div className="text-[11px] text-[#8A867E] font-light leading-relaxed">
              <p>GATE NO 3, PARK FACING, 224</p>
              <p>Sant Nagar, East of Kailash</p>
              <p>New Delhi, Delhi 110065</p>
            </div>
          </div>

          <div className="space-y-1">
            <p className="font-semibold text-[#2C2A27] uppercase tracking-widest text-[10px] flex items-center justify-center md:justify-start gap-1.5">
              <Phone className="w-3.5 h-3.5 text-[#9A7B56]" /> Contact Number
            </p>
            <a 
              href="tel:+919205713551" 
              className="text-[11px] text-[#8A867E] hover:text-[#9A7B56] font-light transition-colors inline-block"
            >
              +91 92057 13551
            </a>
          </div>
        </div>

        {/* Right Column: Information Navigation */}
        <div className="flex flex-wrap justify-center md:justify-end gap-x-6 gap-y-2 font-medium tracking-wide">
          {['About Us', 'Contact', 'FAQ', 'Terms of Use'].map(link => (
            <a 
              key={link} 
              href="#" 
              className="text-[#5A5750] hover:text-[#9A7B56] transition-colors uppercase tracking-wider text-[10px]"
            >
              {link}
            </a>
          ))}
        </div>

      </div>
    </footer>
  );
}

export default Footer;